import {
  isFeatureEnabledForWarehouse,
  WarehouseFeatureEnum,
  type IWarehouse,
  type Nullable
} from '@nova/core';

import { findLoadTypeTriggers, isTriggerEnabled } from '@/utils/loadTypeTrigger';

export interface IdVerificationSettings {
  isEnabled: boolean;
  isRequired: boolean;
}

/**
 * When the appointment's load type has its own triggerSettings configured, they fully replace the
 * warehouse-level rule for the check-in
 */
export function resolveIdVerificationSettings(
  warehouse: Partial<IWarehouse>,
  loadTypeId?: Nullable<string>
): IdVerificationSettings {
  const hasIdValidationFeature = isFeatureEnabledForWarehouse(
    warehouse,
    WarehouseFeatureEnum.IdValidation
  );
  // The load type's audience-specific triggers each carry their own settings, and only some of
  // them configure ID verification, so the first enabled one that actually has settings decides.
  // A disabled trigger must not, which matters because the payload includes those too.
  const triggerSettings = findLoadTypeTriggers(warehouse.triggers, loadTypeId ?? null)
    .filter(isTriggerEnabled)
    .find(trigger => trigger.triggerSettings)?.triggerSettings;

  if (hasIdValidationFeature && triggerSettings) {
    const isEnabled = triggerSettings.enableCheckinIdValidation === true;
    return {
      isEnabled,
      isRequired: isEnabled && triggerSettings.checkinIdValidationRequired === true
    };
  }

  return {
    isEnabled: hasIdValidationFeature && warehouse.settings?.enableCheckinIdValidation === true,
    isRequired: hasIdValidationFeature && warehouse.settings?.checkinIdValidationRequired === true
  };
}
